<template>
  <div>
    <div class="min-h-full">
      <!-- Off-canvas menu for mobile -->
      <SideBarMobile
        :menu="menu"
        @sideBarToggled="toggleSideBar"
        :sideBarIsOpen="sideBarIsOpen"
      />

      <!-- Static sidebar for desktop -->
      <SideBarDesktop :profileMenu="profileMenu" :menu="menu"></SideBarDesktop>

      <!-- Main -->
      <div class="lg:pl-64 flex flex-col min-h-screen">
        <AppHeader :profileMenu="profileMenu" @sideBarToggled="toggleSideBar" />

        <slot />
      </div>

      <JetBanner
        :style="notificationStyle"
        :message="notificationMessage"
        v-if="showNotification"
        @close="showNotification = false"
      />
    </div>
  </div>
</template>

<script>
import AppHeader from "@/Shared/AppHeader";
import SideBarMobile from "@/Shared/SideBarMobile.vue";
import SideBarDesktop from "@/Shared/SideBarDesktop.vue";
import JetBanner from "@/Jetstream/Banner";
import { useI18n } from "vue-i18n";

export default {
  components: {
    AppHeader,
    SideBarMobile,
    SideBarDesktop,
    JetBanner,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  created() {
    if ("banner" in this.$page.props.jetstream.flash) {
      this.showNotification = true;
    }
  },

  data() {
    return {
      sideBarIsOpen: false,
      showNotification: false,
      notificationStyle: "",
      notificationMessage: "",
    };
  },

  methods: {
    toggleSideBar(value) {
      if (value !== undefined) {
        this.sideBarIsOpen = value;
      } else {
        this.sideBarIsOpen = !this.sideBarIsOpen;
      }
    },

    logout() {
      axios.post("/logout").then((response) => {
        window.location = "/";
      });
    },

    showMessage(style, message) {
      this.notificationStyle = style;
      this.notificationMessage = message;
      this.showNotification = true;
    },
  },

  computed: {
    profileMenu() {
      return [
        [{ text: this.t("profile"), route: "profile" }],
        [{ text: this.t("logout"), route: "logout", method: "post" }],
      ];
    },
    menu() {
      return [
        {
          text: this.t("dashboard"),
          iconComponent: "HomeIcon",
          route: "dashboard.index",
        },
        {
          text: this.t("calendar"),
          iconComponent: "CalendarIcon",
          route: "calendar.index",
        },
        {
          text: this.t("customers"),
          iconComponent: "UsersIcon",
          route: "customers.index",
        },
        {
          text: this.t("personnel"),
          iconComponent: "UserGroupIcon",
          route: "users.index",
        },
        {
          text: this.t("roles"),
          iconComponent: "ShieldCheckIcon",
          route: "roles.index",
        },
        {
          text: this.t("physical_services"),
          iconComponent: "ViewGridIcon",
          route: "physical-services.index",
        },
        {
          text: this.t("chemical_services"),
          iconComponent: "BeakerIcon",
          route: "chemical-services.index",
        },
        {
          text: this.t("equipment"),
          iconComponent: "DesktopComputerIcon",
          route: "equipment.index",
        },
        {
          text: this.t("quotations"),
          iconComponent: "DocumentTextIcon",
          route: "quotations.index",
        },
        {
          text: this.t("profile"),
          iconComponent: "UserIcon",
          route: "profile",
        },
      ];
    },
  },

  watch: {
    $page: {
      deep: true,
      handler(page) {
        if ("banner" in page.props.jetstream.flash) {
          this.showNotification = true;
          this.notificationStyle =
            this.$page.props.jetstream.flash?.bannerStyle || "success";
          this.notificationMessage =
            this.$page.props.jetstream.flash?.banner || "";
        } else {
          this.showNotification = false;
        }
      },
    },
  },
};
</script>

<i18n>
{
  "es": {
    "dashboard": "Inicio",
    "calendar": "Calendario",
    "customers": "Clientes",
    "personnel": "Personal",
    "roles": "Permisos y roles",
    "search": "Buscar",
    "physical_services": "Servicios físicos",
    "chemical_services": "Servicios químicos",
    "equipment": "Equipos de medición",
    "quotations": "Cotizaciones",
    "profile": "Ver perfil",
    "notifications": "Notificaciones",
    "support": "Soporte",
    "logout": "Cerrar sesión"
  }
}
</i18n>
